/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { Container, Grid } from '@mui/material';

export const SocialMediaContainer = styled(Container)`
  display: flex;
  margin-top: 5%;
  margin-bottom: 5%;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CardGrid = styled(Grid)`
  display: flex;
  justify-content: center;
`;
